<template>
    <div class="ConversationColorHelp">
        <a-tabs :animated="false" default-active-key="2">
            <a-tab-pane key="2" :tab="$t('message.chatBar')">
                <div class="helpContainer">
                    <div class="helpContent">
                        <div class="colorBox" style="background-color: #3699ff"></div>
                        <div class="helpContentText">
                            <h4>{{ $t("message.unreadTitle") }}</h4>
                            <p>{{ $t("message.unreadMsg") }}</p>
                        </div>
                    </div>
                    <div class="helpContent">
                        <div class="colorBox" style="background-color: #afafaf"></div>
                        <div class="helpContentText">
                            <h4>{{ $t("message.visitorLeftTitle") }}</h4>
                            <p>{{ $t("message.visitorLeftChat") }}</p>
                        </div>
                    </div>
                    <div class="helpContent">
                        <div class="colorBox" style="background-color: #1bc5bd"></div>
                        <div class="helpContentText">
                            <h4>{{ $t("message.activeChatTitle") }}</h4>
                            <p>{{ $t("message.activeChatMsg") }}</p>
                        </div>
                    </div>
                    <div class="helpContent">
                        <div class="colorBox" style="background-color: #ffa800"></div>
                        <div class="helpContentText">
                            <h4>{{ $t("message.autoAssignedTitle") }}</h4>
                            <p>{{ $t("message.autoAssignMsg") }}</p>
                        </div>
                    </div>
                    <div class="helpContent">
                        <div class="colorBox" style="background-color: #f64e60"></div>
                        <div class="helpContentText">
                            <h4>{{ $t("message.watchModeTitle") }}</h4>
                            <p>{{ $t("message.watchModeMsg") }}</p>
                        </div>
                    </div>
                </div>
            </a-tab-pane>
            <a-tab-pane key="1" :tab="$t('message.chatList')">
                <div class="helpContainer">
                    <div class="helpContent">
                        <div class="colorBox" style="background-color: #ffaaf0"></div>
                        <div class="helpContentText">
                            <h4>{{ $t("message.lostChat") }}</h4>
                            <p>{{ $t("message.repLostConn") }}</p>
                        </div>
                    </div>
                    <div class="helpContent">
                        <div class="colorBox" style="background-color: #a581bc"></div>
                        <div class="helpContentText">
                            <h4>{{ $t("message.chatWidthDelay") }}</h4>
                            <p>{{ $t("message.repChatWidthDelay") }}</p>
                        </div>
                    </div>
                </div>
            </a-tab-pane>
        </a-tabs>
    </div>
</template>

<script>
export default {
    name: "ConversationColorHelp",
};
</script>

<style lang="scss">
.ConversationColorHelp {
    .ant-tabs-nav-scroll {
        display: flex;
        justify-content: center;
    }

    .helpContainer {
        display: flex;
        flex-direction: column;

        .helpContent {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-bottom: 0.4em;

            .helpContentText {
                margin-left: 0.5em;
                display: flex;
                flex-direction: column;
                width: 30em;
                height: 5em;

                h4 {
                    margin-bottom: 0.3em;
                    font-size: 1.2em;
                }

                p {
                    font-size: 0.9em;
                }
            }

            .colorBox {
                width: 4.5em;
                height: 4.5em;
                background-color: red;
                border-radius: 8px;
            }
        }
    }
}
</style>
